import React, { Component } from 'react';

import blockLibrary from '../data/blockLibrary';
import PopupClose from '~/components/popups/Close';
import subItemButtons from './menu';

export default class AddBlockPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: 'all'
    };
  }

  getFilteredBlocks() {
    const { filter } = this.state;
    const { onClick, parent, aside } = this.props;

    // Filter
    let blocks = blockLibrary;
    if (filter != 'all') {
      blocks = blockLibrary.filter(b => b.blockType == filter);
    }
    // Filter if block will be child
    if (parent != null && !aside) {
      blocks = blocks.filter(b => b.canBeChild);
    }

    // Filter by aside-types
    if (aside) {
      blocks = blocks.filter(b => b.onlyAside);
    } else {
      blocks = blocks.filter(b => !b.onlyAside);
    }

    // Sorting by 'sort' key
    blocks.sort((a,b) => (a.sort > b.sort) ? 1 : ((b.sort > a.sort) ? -1 : 0));

    // Prepare html
    blocks = blocks.map(block => {
      return (
        <div key={block.type} className="tilda-item__wrapper">
          <button
            type="button"
            onClick={() => onClick(block.type)}
            className="tilda-prev__btn"
          >
            <img alt="img" src={`/static/img/constructor/${block.type}.png`} />
          </button>
          <p className="text">{block.label}</p>
        </div>
      )
    });

    if (blocks.length == 0) {
      blocks = (
        <p className="txt">Блоков по этому фильтру не найдено</p>
      );
    }

    return blocks;
  }

  prepareFilters() {

    const { filter } = this.state;

    const btns = subItemButtons.map(btn => {

      const btnClasses = ['tilda__sub-item'];
      if (filter == btn.name) btnClasses.push('tilda__sub-item--active');

      return (
        <button
          key={btn.name}
          className={btnClasses.join(' ')}
          onClick={() => this.setState({ filter: btn.name })}
          type="button"
        >
          {btn.text}
        </button>
      )
    })

    return btns;
  }

  render() {
    return (
      <div className="popup add-block-popup">
        <div className="popup__close-container close_add-block"><PopupClose/></div>
        <div className="tilda__header">
          <ul className="tilda__main-header">
            <li className="tilda__main-item tilda__main-item--all tilda__main-item--active">
              Библиотека блоков
            </li>
          </ul>
          <ul className="tilda__sub-header">
            {this.prepareFilters()}
          </ul>
        </div>
        <div className="tilda__popup-wrapper">
          <div className="tilda__popup-content">
            {this.getFilteredBlocks()}
          </div>
        </div>
      </div>
    )
  }
}
